import { useState } from "react";

export type ContactFields = {
  nombre: string;
  email: string;
  whatsapp: string;
  perfil: string;
  mensaje: string;
};

export type ContactErrors = Partial<Record<keyof ContactFields, string>>;
export type SubmitStatus = "idle" | "loading" | "success" | "error";

const initial: ContactFields = { nombre: "", email: "", whatsapp: "", perfil: "", mensaje: "" };

function validate(values: ContactFields): ContactErrors {
  const errors: ContactErrors = {};
  if (values.nombre.trim().length < 2) errors.nombre = "Ingresá tu nombre.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) errors.email = "Ingresá un email válido.";
  if (values.whatsapp.trim() && !/^\+?[\d\s()-]{8,20}$/.test(values.whatsapp.trim()))
    errors.whatsapp = "Ingresá un número válido, con código de país.";
  if (!values.perfil) errors.perfil = "Seleccioná un perfil.";
  if (values.mensaje.trim().length < 10) errors.mensaje = "Contanos un poco más (mínimo 10 caracteres).";
  return errors;
}

export function useContactForm() {
  const [values, setValues] = useState<ContactFields>(initial);
  const [errors, setErrors] = useState<ContactErrors>({});
  const [status, setStatus] = useState<SubmitStatus>("idle");

  const setField = (field: keyof ContactFields, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const found = validate(values);
    setErrors(found);
    const firstInvalid = Object.keys(found)[0];
    if (firstInvalid) {
      document.getElementById(`field-${firstInvalid}`)?.focus();
      return;
    }
    setStatus("loading");
    try {
      await new Promise((resolve) => setTimeout(resolve, 900));
      setStatus("success");
      setValues(initial);
    } catch {
      setStatus("error");
    }
  };

  const reset = () => setStatus("idle");

  return { values, errors, status, setField, handleSubmit, reset };
}
